export default __webpack_public_path__ + "static/media/mobileWef4Full.c38491c0.png";